/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S14_P1_EmInputs */

const tr_mesafeli_s14_p1_em = /** @type {(inputs: Mesafeli_S14_P1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"OLDUĞU GİBİ"`)
};

const en_mesafeli_s14_p1_em = /** @type {(inputs: Mesafeli_S14_P1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"AS IS"`)
};

const de_mesafeli_s14_p1_em = /** @type {(inputs: Mesafeli_S14_P1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"WIE BESEHEN"`)
};

const ru_mesafeli_s14_p1_em = /** @type {(inputs: Mesafeli_S14_P1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`«КАК ЕСТЬ»`)
};

/**
* | output |
* | --- |
* | "\"AS IS\"" |
*
* @param {Mesafeli_S14_P1_EmInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s14_p1_em = /** @type {((inputs?: Mesafeli_S14_P1_EmInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S14_P1_EmInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s14_p1_em(inputs)
	if (locale === "de") return de_mesafeli_s14_p1_em(inputs)
	if (locale === "ru") return ru_mesafeli_s14_p1_em(inputs)
	return tr_mesafeli_s14_p1_em(inputs)
});